import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=767a37ee&scoped=true&"
import script from "./productCategory.vue?vue&type=script&lang=js&"
export * from "./productCategory.vue?vue&type=script&lang=js&"
import style1 from "./productCategory.vue?vue&type=style&index=1&id=767a37ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767a37ee",
  null
  
)

export default component.exports